const normalizeText = value => typeof value === 'string' ? value.trim().toLowerCase() : ''

const belongsToRegulation = (exemption, regulation) => {
    if (!exemption || !regulation) {
        return false
    }

    if (exemption.legislationKey && regulation.key) {
        return exemption.legislationKey === regulation.key
    }

    if (exemption.legislationId !== null
        && typeof exemption.legislationId !== 'undefined'
        && regulation.id !== null
        && typeof regulation.id !== 'undefined') {
        return String(exemption.legislationId) === String(regulation.id)
    }

    return !!normalizeText(exemption.legislation)
        && normalizeText(exemption.legislation) === normalizeText(regulation.name)
}

const buildRegulationReviewViewModel = (legislations, exemptions, checkerRegistry) => {
    const regulationRows = Array.isArray(legislations) ? legislations : []
    const exemptionRows = Array.isArray(exemptions) ? exemptions : []
    const assignedExemptionIndexes = new Set()

    const items = regulationRows.map((regulation, index) => {
        const relatedExemptions = exemptionRows.reduce((result, exemption, exemptionIndex) => {
            if (belongsToRegulation(exemption, regulation)) {
                assignedExemptionIndexes.add(exemptionIndex)
                result.push({
                    sourceIndex: exemptionIndex,
                    value: exemption,
                })
            }

            return result
        }, [])
        const evaluation = checkerRegistry.evaluate({
            regulation,
            regulationIndex: index,
            legislations: regulationRows,
            exemptions: relatedExemptions.map(item => item.value),
        })

        return {
            index,
            regulation,
            exemptions: relatedExemptions,
            evaluation,
        }
    })

    const unassignedExemptions = exemptionRows.reduce((result, exemption, sourceIndex) => {
        if (!assignedExemptionIndexes.has(sourceIndex)) {
            result.push({ sourceIndex, value: exemption })
        }

        return result
    }, [])

    return {
        items,
        unassignedExemptions,
    }
}

export {
    belongsToRegulation,
    buildRegulationReviewViewModel,
}
